import React, { Component } from 'react';
import { Table } from 'antd';
import moment from 'moment';
import { queryBusinessLog } from '@api/common/business';
import getLink from './getLink';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        list: [],
        pagination: {},
      },
    };
  }

  componentDidMount() {
    this.current = 1;
    this.getLogData(this.props.businessUuid);
  }

  componentWillReceiveProps(nextProps) {
    this.getLogData(nextProps.businessUuid);
  }

  getLogData = itemUuid => {
    const { pageSize } = this.state.data.pagination;
    queryBusinessLog({
      itemUuid,
      limit: pageSize || 5,
      start: this.current || 1,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: {
            list: res.data,
            pagination: {
              total: res.totalSize,
              pageSize: 5,
            },
          },
        });
      }
    });
  };

  columns = () => {
    return [
      {
        title: '操作时间',
        dataIndex: 'createTime',
        render: text =>
          text ? <span>{moment.unix(text / 1000).format('YYYY-MM-DD HH:mm')}</span> : null,
      },
      {
        title: '操作内容',
        dataIndex: 'operate',
        render: (text, record) => {
          return getLink(record);
        },
      },
      {
        title: '操作人员',
        dataIndex: 'createUser',
      },
    ];
  };

  render() {
    const {
      data: { list, pagination },
    } = this.state;
    return (
      <Table
        columns={this.columns()}
        dataSource={list}
        pagination={pagination}
        rowKey="uuid"
        bordered
      />
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/incubator/contract/detail/TableLog.js